module.exports = __webpack_public_path__ + "5e19099caf3daa730ce58ad926af8964.svg";